var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinSolidSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77199 7.1605C2.72197 7.22811 2.68867 7.30661 2.6748 7.38957C2.65991 7.47524 2.66621 7.56325 2.69315 7.64593C2.72009 7.7286 2.76685 7.80343 2.82935 7.86388L4.98106 10.0112L2.60737 12.3849C2.31447 12.6778 2.31447 13.1527 2.60737 13.4456C2.90026 13.7385 3.37513 13.7385 3.66803 13.4456L6.04279 11.0708L8.07347 13.0973C8.12327 13.1467 8.18233 13.1858 8.24726 13.2123C8.31219 13.2389 8.38172 13.2523 8.45186 13.2519H8.53713C8.61869 13.2359 8.69538 13.2011 8.76108 13.1502C8.82678 13.0993 8.87967 13.0338 8.91552 12.9588L10.6209 9.54797L13.179 6.98986C13.2775 6.8906 13.333 6.75662 13.3336 6.61681C13.334 6.54667 13.3205 6.47714 13.294 6.41221C13.2675 6.34727 13.2284 6.28822 13.179 6.23842L9.68295 2.73701C9.5831 2.63775 9.44802 2.58203 9.30723 2.58203C9.16643 2.58203 9.03136 2.63775 8.93151 2.73701L6.3734 5.29512L2.96259 7.00052C2.88732 7.03806 2.82201 7.09288 2.77199 7.1605Z",
    fill: "#677B99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSolidSmall);
export default __webpack_public_path__ + "static/media/pin-solid-small.3ea229ebea3601e70def910b412257ec.svg";
export { ForwardRef as ReactComponent };